module.exports = {
    doublegame: {}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 39
// module chunks = 0